import React, { Component } from 'react'
import { PageWrapper } from '../components/sections'
import { getPageData, scrollToDiv, getImageSrc } from '../utils/helpers'
import { ServiceItem } from '../components'
import ClientLogos from '../assets/images/logos/logos-clients.png'
import ChevDown from '../assets/images/icon-white-chevs-down.svg'
import Button from '../components/Button'
import CalendarIcon from '../assets/images/icon-white-calendar.svg'
import HomeVideo from '../assets/homepage-video.mp4'

class Homepage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollDiv: 'homepage-main',
    }
    this.onButtonClick = this.onButtonClick.bind(this)
  }

  onButtonClick() {
    scrollToDiv(this.state.scrollDiv)
  }

  render() {
    const { scrollDiv } = this.state
    const { data } = this.props
    const wp = getPageData(data, 'Home')
    return (
      <PageWrapper page="front-page">
        <section className="hero hero--home">
          <div className="hero__text-wrapper hero__text-wrapper--home">
            <h2 className="title title--white title--lg">
              Looking to see clearer skies?
            </h2>
            <h1 className="title title--white title--mid">
              Commercial & residential window cleaning services.
            </h1>
            <p className="text text--white text--lg">
              Improving the view across Basingstoke & surrounding areas.
            </p>
            <button className="button" onClick={this.onButtonClick}>
              Learn More
            </button>
          </div>
          <div className="hero__image-wrapper">
            <img
              className="hero__image"
              src={getImageSrc(wp.hero_background)}
              alt="Window Cleaning"
            />
          </div>
          <button className="hero__chev-wrapper" onClick={this.onButtonClick}>
            <img src={ChevDown} alt="Chevrons Down" />
          </button>
        </section>
        <section className="home-main" id={scrollDiv}>
          <div className="home-main__text-top">
            <h2 className="title">Reliable, safe and trustworthy</h2>
            <p className="text text--lg">
              Offering professional window and gutter cleaning services since
              2009, we’re passionate about professionalism, reliability and our
              standard of work. No job or project is too small or too big.
            </p>
          </div>
          <div className="home-services">
            <div className="home-services__row home-services__row--top">
              <ul className="home-services__list home-services__list--top">
                <ServiceItem
                  title="Pressure Washing"
                  text="Clear H2o offer a pressure washing services ranging from driveways, paved areas, curb stones, rendering, roofs, car parks and more."
                  url="/services/#services-intro"
                />
                <ServiceItem
                  title="Commercial/Domestic Window Cleaning"
                  text="We can clean it all from just the windows to all the Upvc framework roofs internally and externally just let us know your requirements."
                  url="/services/#services-intro"
                />
                <ServiceItem
                  title="Gutter Clearing"
                  text="If you are buying or selling your property or just want to keep up with the exterior (outlook) maintenance all year round."
                  url="/services/#services-intro"
                />
              </ul>
              <div className="home-services__image-wrapper home-services__image-wrapper--top">
                <img
                  className="home-services__image"
                  src={getImageSrc(wp.row_image_top)}
                  alt="Service Outline"
                />
              </div>
            </div>
            <div className="home-services__row home-services__row--bottom">
              <div className="home-services__image-wrapper">
                <img
                  className="home-services__image"
                  src={getImageSrc(wp.row_image_bottom)}
                  alt="Service Outline"
                />
              </div>
              <ul className="home-services__list home-services__list--right">
                <ServiceItem
                  title="Cladding & Solar Panel Cleaning"
                  text="Regular cleaning of your building/house should be part of a maintenance program that helps to protect your investment."
                  url="/services/#maintaining-quality"
                />
                <ServiceItem
                  title="Conservatory Cleaning"
                  text="We offer a complete conservatory cleaning service to restore and clean your conservatory to an as-new condition."
                  url="/services/#maintaining-quality"
                />
              </ul>
            </div>
          </div>
        </section>
        <section className="home-clients">
          <div className="home-video-wrapper">
            <video className="video-container video-container-overlay" controls>
              <source src={HomeVideo} type="video/mp4" />
            </video>
          </div>
          <div className="home-clients__text-top">
            <h2 className="title title--white">
              Trusted by organisations across Hampshire
            </h2>
            <p className="text text--white">
              Working with schools, offices, blocks of apartments, hospitals and
              more, we’re proud to have a large number of clients within 100
              mile radius of Basingstoke who continue to grow year by year.
            </p>
          </div>
          <div className="home-clients__logos-wrapper">
            <img
              className="home-clients__logos"
              src={ClientLogos}
              alt="Our Clients"
            />
          </div>
        </section>
        <section className="cta">
          <div className="cta__column-left">
            <h3 className="title title--cta">Interested in our services?</h3>
            <p className="text">
              Speak to us today to discuss how our services can benefit you.
            </p>
          </div>
          <div className="cta__column-right">
            <Button text="Learn more" to="/about" outline />
            <a
              className="button booking-button"
              href="https://book-clear-h2o.web.app/"
              target="_blank"
            >
              <img src={CalendarIcon} alt="" />
              Create Booking
            </a>
          </div>
        </section>
      </PageWrapper>
    )
  }
}

export default Homepage

export const queryHomepage = graphql`
  query homepage {
    allWordpressPage {
      edges {
        node {
          acf {
            page_reference
            hero_title
            hero_subtitle
            hero_text
            hero_background {
              localFile {
                childImageSharp {
                  sizes {
                    originalImg
                  }
                }
              }
            }
            intro_title
            intro_text
            services_list_top {
              title
              text
            }
            row_image_top {
              localFile {
                childImageSharp {
                  sizes {
                    originalImg
                  }
                }
              }
            }
            services_list_bottom {
              title
              text
            }
            row_image_bottom {
              localFile {
                childImageSharp {
                  sizes {
                    originalImg
                  }
                }
              }
            }
            clients_title
            clients_text
            cta_title
            cta_text
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js